import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/AssociationField/label";
import asArray from "data/util/asArray";

export class AssociationFieldlabel extends BaseFormItem {
    render() {
        const {
            activeRecord,
            descriptor
        } = this.props;

        const value = asArray(activeRecord.get(descriptor.key))
            .map(v => v.getLabel())
            .join(", ");

        return <Control {...this.getPlumbingProps()}
                   value={value}
                   enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

export default AssociationFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/AssociationField/label.js